module.exports = __webpack_public_path__ + "ff7325d81885166b583a8de59d233642.svg";